import { useLogger } from '@booksy-com/vue-tools'
import { useCore } from '@/composables/core/index.js'
import { EVENTS, WEBVIEW_TYPES } from '@/lib/consts.js'
import { useEmitter } from '@/composables/emitter'

const logger = useLogger('router.guard.version-check')

export default function (to, from) {
  const emitter = useEmitter()
  const { store } = useCore()

  logger.debug(to.path)

  const routeNameChanged = to.name !== from.name
  const isWebView = [WEBVIEW_TYPES.IOS, WEBVIEW_TYPES.ANDROID].includes(store.state.app.webView)

  // For WebView EVENT.CHECK_VERSION_CHANGE is emitted after App Resume
  if (!isWebView && routeNameChanged) {
    emitter.emit(EVENTS.CHECK_VERSION_CHANGE)
  }
}
